import type { FaireProductEntity } from "../../entity_types/product";

export const p_cjyosafbex: FaireProductEntity = {
  token: "p_cjyosafbex",
  type: "product",
  name: "Paint 'N Play Squishy Eggs",
  brandToken: "b_5g5bvol3h2",
  brandName: "Dan&Darci",
  imageUrl:
    "https://cdn.faire.com/fastly/ecb09531a6f03c54d9af60feff568080e16c091a73d3f48eb1e85ff17aaa130e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d97ce81056c39af51e6a6c146f65f8747f47898d1ccec7e584e574861ebbab91.jpeg",
    "https://cdn.faire.com/fastly/6ab7d4b0aca6f0f1c8f27deb298b07dde17d9ad928ec77716334a7a6a243a1b8.jpeg",
    "https://cdn.faire.com/fastly/b216da1651b7dac5dcd27ed89cdae5e5e0d3103a060ce9f0b439f27f19a4e163.jpeg",
    "https://cdn.faire.com/fastly/bacbd97a77a224ef6d0de01a45bedbcecae825c25c5a0b7fe86527a8e71ebc74.jpeg",
    "https://cdn.faire.com/fastly/8b45b9e68840ca0035a81e8deafa1c7b30aa82d7fd9d4e4b8c18ee8ed393fbd1.jpeg",
    "https://cdn.faire.com/fastly/ff749016ccbf204a288a3b8f60b87d429e9196cba69a62a6bb83b4adf81ecc9c.jpeg",
    "https://cdn.faire.com/fastly/e3839867e1ac72acbc791edd688a12fb5916c1b3495571f975c847df9dd82785.jpeg",
  ],
  priceDollars: 10,
  description:
    "EVERYTHING YOU NEED TO PAINT YOUR OWN CUTE SQUISHY EASTER EGGS: Complete kit includes 6 blank super-squishy eggs, 2 paintbrushes, and 6 fabric paint vials.\nSUPER-SQUISHY SLOW-RISING MATERIAL: The eggs are made from premium materials to ensure a feel-good squeeze and extra slow-rising motion.\nDURABLE PAINT: Includes innovative paint to ensure the color sticks well onto the squishes and doesn't rub off. A great craft activity and art project for the whole family.\nA FUN GIFT FOR ALL AGES: Great set for individual play or as a group activity.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:33.503Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
